"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchStatusType = void 0;
var LaunchStatusType;
(function (LaunchStatusType) {
    LaunchStatusType["Unknown"] = "unknown";
    LaunchStatusType["Error"] = "error";
    LaunchStatusType["Unavailable"] = "unavailable";
    LaunchStatusType["Accepted"] = "accepted";
    LaunchStatusType["Queued"] = "queued";
    LaunchStatusType["Requested"] = "requested";
    LaunchStatusType["ModelError"] = "modelerror";
    LaunchStatusType["Ready"] = "ready";
    LaunchStatusType["Serviced"] = "serviced";
    LaunchStatusType["Cancelled"] = "cancelled";
    LaunchStatusType["Completed"] = "completed";
})(LaunchStatusType = exports.LaunchStatusType || (exports.LaunchStatusType = {}));
//# sourceMappingURL=LaunchStatusType.js.map